import { FC } from "react";
import { Box, IconButton, makeStyles } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import copy from "copy-to-clipboard";

import TooltipPopover from "../../../../../components/TooltipPopover";

const useStyles = makeStyles(() => ({
  imageContainer: {
    width: 150,
    height: 150,
    margin: 4,
    borderRadius: 10,
    overflow: "hidden",
    position: "relative",

    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      zIndex: 5,
    },

    "& .img-data": {
      width: "100%",
      position: "absolute",
      zIndex: 10,
      bottom: 0,
      display: "flex",
      justifyContent: "flex-end",

      "& .img-copy-icon-container": {
        backgroundColor: "rgb(238 238 238)",
      },
    },
  },
}));

const ImageItem: FC<ImageItemProps> = ({ entry }) => {
  const classes = useStyles({});

  const handleCopyUrl = async (entry: any) => {
    try {
      // await navigator.clipboard.writeText(entry.src);
      // for browser compatibility we used copy-to-clipboard instead
      copy(entry.src);
    } catch (ex) {}
  };

  return (
    <Box className={classes.imageContainer}>
      <img src={entry.src} alt={entry.src} />

      <Box className="img-data">
        <Box className="img-copy-icon-container" onClick={() => handleCopyUrl(entry)}>
          <TooltipPopover message="Copy Url">
            <IconButton>
              <FileCopyIcon fontSize="small" color="primary" />
            </IconButton>
          </TooltipPopover>
        </Box>
      </Box>
    </Box>
  );
};

interface ImageItemProps {
  entry: any;
}

export default ImageItem;
